import React from 'react';
import PropTypes from 'prop-types';

const RamblaMark = (props) => (
  <g fill="currentColor" stroke="none" {...props}>
    <path d="m29.79,73.47c0-.2.01-.4.02-.6,1.08-23.57,20.55-42.55,44.14-43.09,6.74-.15,13.16,1.17,18.95,3.67-3.95-.17-8.21.43-12.51,1.82-7.1,2.29-26.62,11.13-37.43,40.69-2.64,7.22-13.42,5.18-13.17-2.5Z" />
    <path d="m99.76,112.84c-7.11,4.68-15.62,7.39-24.77,7.39-.16,0-.32,0-.48,0-17.62-.18-30.03-17.34-25.17-34.27,7.13-24.85,21.13-37.96,33.82-42.05,7.97-2.57,15.59-1.61,18.97,2.41,3.36,3.99,3.67,9.83.76,14.5-4.11,6.61-12.98,8.98-23.73,6.34-9.79-2.41-13.92,2.47-15.24,4.68-4.03,6.72-.94,18.31,7.36,27.54,7.76,8.65,17.73,13.23,28.49,13.47Z" />
    <path d="m120.22,75c0,2.3-.17,4.55-.5,6.76-2.74,18.28-24.47,26.63-38.53,14.63-1.3-1.11-2.36-2.18-3.16-3.08-6.34-7.06-7.76-14.43-6.33-16.83.87-1.45,3.99-.85,5.31-.53,14.75,3.62,27.31-.25,33.6-10.36,2.65-4.26,3.72-9.11,3.24-13.76,4.05,6.77,6.38,14.7,6.38,23.16Z" />
    <circle cx="34.69" cy="93.62" r="4.9" />
  </g>
);

const icons = {
  edit: (
    <>
      <g
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M15.3 3.1a2 2 0 0 1 2.8 0l.8.8a2 2 0 0 1 0 2.8L12.4 13.2l-3.5.7.7-3.5L15.3 3.1z" />
      </g>
      <RamblaMark transform="translate(-0.1 10.1) scale(0.092)" />
    </>
  ),
  share: (
    <>
      <RamblaMark transform="translate(5.45 5.45) scale(0.0873)" />
      <g
        fill="none"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <circle cx="12" cy="3.3" r="1.7" />
        <circle cx="4.7" cy="16.6" r="1.7" />
        <circle cx="19.3" cy="16.6" r="1.7" />
        <path d="M12 7.3V5.3" />
        <path d="M8 14.25l-1.9 1.1" />
        <path d="M16 14.25l1.9 1.1" />
      </g>
    </>
  ),
  preview: (
    <>
      <g
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M2.4 12C5.4 6.9 18.6 6.9 21.6 12C18.6 17.1 5.4 17.1 2.4 12Z" />
      </g>
      <RamblaMark transform="translate(6.15 6.15) scale(0.078)" />
    </>
  ),
  addModule: (
    <>
      <g
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <rect x="3" y="5" width="14" height="14" rx="2.5" />
        <path d="M19.7 1.9v5.2" />
        <path d="M17.1 4.5h5.2" />
      </g>
      <RamblaMark transform="translate(3.36 5.36) scale(0.0885)" />
    </>
  ),
};

const RamblaActionIcon = ({ name, size = 28, className = '' }) => (
  <svg
    aria-hidden="true"
    className={className}
    focusable="false"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    {icons[name]}
  </svg>
);

RamblaMark.propTypes = {
  transform: PropTypes.string.isRequired,
};

RamblaActionIcon.propTypes = {
  name: PropTypes.oneOf(Object.keys(icons)).isRequired,
  size: PropTypes.number,
  className: PropTypes.string,
};

export default RamblaActionIcon;
